import { API_ROOT } from 'src/constants';
import { AdvisorProfile } from 'src/types/Advisor';
import Request, { setData, setMethod, setURL } from '../index';
import { getNamespaceName } from '../objects/namespaces';

/**
 * createAdvisorProfile
 *
 * create information about an Advisor in Lendsmart.
 *
 * @param data { object } Options for type, email, first_name, etc.
 */
export const createAdvisorProfile = (data: any) =>
  Request<any>(
    setURL(`${API_ROOT}/${getNamespaceName()}/advisor_profiles`),
    setMethod('POST'),
    setData(data)
  ).then((response) => response.data);

/**
 * getAdvisorProfile
 *
 * Returns an advisor profile for the account id.
 *
 */
export const getAdvisorProfile = (accountId:string) =>
  Request<AdvisorProfile>(
    setURL(`${API_ROOT}/advisor_profiles/account/${accountId}`),
    setMethod('GET')
  ).then((response) => response.data);

/**
 * updateAdvisorProfile
 *
 * update information about an Advisor in Lendsmart.
 *
 * @param id { string } The ID of the advisor to update.
 * @param data { object } The fields to update. Values not included in this
 * parameter will be left unchanged.
 */

export const updateAdvisorProfile = (data: any) =>
  Request<AdvisorProfile>(
    setURL(`${API_ROOT}/advisor_profiles/${data.id}`),
    setMethod('PUT'),
    setData(data)
  ).then((response) => response.data);

/**
 *
 * deleteAdvisorProfileById
 *
 * delete information about an Advisor in Lendsmart.
 *
 */
export const deleteAdvisorProfile = (data: any) =>
  Request<AdvisorProfile>(
    setURL(`${API_ROOT}/advisor_profiles/${data.id}`),
    setMethod('DELETE'),
    setData(data)
  ).then((response) => response.data);
/**
 *
 * getAdvisorProfileByEmail
 *
 * Returns an advisor profile for the the given email.
 *
 *
 * @param email { string } The email of the advisor to access.
 *
 */

export const getAdvisorProfileByEmail = (email: any) =>
  Request<AdvisorProfile>(
    setURL(`${API_ROOT}/advisor_profiles/email/${email}`),
    setMethod('GET')
  ).then((response) => response.data);